import { Box, styled } from '@mui/material';
import {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_EXPANDED_WIDTH,
} from 'new/components/AppBar/Sidebar';
import IconFontAwesome from 'new/components/IconFontAwesome';
import LinkButton from 'new/components/LinkButton';
import useToggle from 'new/hooks/useToggle';
import ModalGoLive from './components/ModalGoLive';

const GoLiveNotificationContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'flex-end',
  width: '100%',
  paddingBottom: theme.spacing(2),

  '.notificationContent': {
    height: 80,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#fff',

    '.notificationContentInner': {
      textAlign: 'center',

      button: {
        height: 80,
        backgroundColor: theme.palette.success.main,
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '1.15rem',
        textDecoration: 'none',
        border: `1px solid ${theme.palette.success.contrastText}`,
      },
    },
  },
}));

const StyledLinkButton = styled(LinkButton)({
  div: {
    display: 'inline',
  },
});

type Props = {
  isExpanded: boolean;
  isHovered: boolean;
  refetch: () => void;
};

const GoLiveNotification: React.FC<Props> = ({
  isExpanded,
  isHovered,
  refetch,
}) => {
  const [isModalOpen, setIsModalOpen] = useToggle(false);

  const hasWideLayout = isExpanded || isHovered;

  return (
    <>
      <GoLiveNotificationContainer>
        <Box className="notificationContent">
          <Box
            className="notificationContentInner"
            width={
              hasWideLayout ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH
            }
          >
            {hasWideLayout ? (
              <StyledLinkButton onClick={setIsModalOpen}>
                Ready to add members?
                <br />
                Click HERE
              </StyledLinkButton>
            ) : (
              <IconFontAwesome name="faExclamationCircle" />
            )}
          </Box>
        </Box>
      </GoLiveNotificationContainer>
      <ModalGoLive
        open={isModalOpen}
        onClose={setIsModalOpen}
        refetch={refetch}
      />
    </>
  );
};

export default GoLiveNotification;
